import {ServiceClass} from '@/decorators';
import {CableCoreModel, CreateEditCableCoreViewModel, UpdateCableCoreSortOrderModel} from '../models';
import {BaseApi} from './base.api';

@ServiceClass()
export class CableCoresApi extends BaseApi {
    public getCableCores(cableId: string, filter: any = {}) {
        return this.GET_RequestAsync<CableCoreModel[]>(`${this.ApiUrl}/cables/${cableId}/cable-cores?filter=${encodeURIComponent(JSON.stringify(filter))}`);
    }

    public getCableCoreById(id: string) {
        return this.GET_RequestAsync<CableCoreModel>(`${this.ApiUrl}/cable-cores/${id}`);
    }

    // public createCableCore(cableId: string, data: CreateEditCableCoreViewModel) {
    //     return this.POST_RequestAsync<CableCoreModel>(`${this.ApiUrl}/cables/${cableId}/cable-cores`, data);
    // }

    public createCableCoresMultiple(cableId: string, afterOrder: number, data: CreateEditCableCoreViewModel[]) {
        return this.POST_RequestAsync<CableCoreModel[]>(`${this.ApiUrl}/cables/${cableId}/cable-cores/multiple?afterOrder=${afterOrder}`, data);
    }

    public createCoreWithoutCable(data: CreateEditCableCoreViewModel) {
        return this.POST_RequestAsync<CableCoreModel>(`${this.ApiUrl}/cables/cable-cores/add-without-cable`, data);
    }

    public updateCableCore(cableCoreId: string, data: CreateEditCableCoreViewModel) {
        delete data.id;
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/cable-cores/${cableCoreId}`, data);
    }

    public markCableCoreActive(cableCoreId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/cable-cores/${cableCoreId}/mark-active`, {});
    }

    public markCableCoreInactive(cableCoreId: string) {
        return this.PATCH_RequestAsync<void>(`${this.ApiUrl}/cable-cores/${cableCoreId}/mark-inactive`, {});
    }

    public deleteCableCore(id: string) {
        return this.DELETE_RequestAsync<void>(`${this.ApiUrl}/cable-cores/${id}`);
    }

    public updateSortOrder(cableId: string, data: UpdateCableCoreSortOrderModel) {
        return this.POST_RequestAsync<void>(`${this.ApiUrl}/cables/${cableId}/cable-cores/sort-order`, data);
    }

    public getConnectedCoresOfLocation(locationId: string) {
        return this.GET_RequestAsync<CableCoreModel[]>(`${this.ApiUrl}/cable-cores/connected-cores-of-location/${locationId}`);
    }
}
